"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExposureLogRequest = exports.getParameter = exports.getTreatment = exports.createBulkExposureLogRequest = exports.createExposureLogRequest = exports.createBulkTreatmentRequest = exports.createTreatmentRequest = exports.normalizeTreatment = void 0;

var _utils = require("./utils");

var _adaptParameters = function _adaptParameters() {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return parameters.map(function (parameter) {
    return (0, _utils.buildParameter)(parameter.key, parameter.value, parameter.isAssigned);
  });
};

var _findParameters = function _findParameters() {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var predicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  return parameters.reduce(function (accumulator, parameter) {
    if (predicate(parameter)) {
      accumulator.push(parameter);
    }

    return accumulator;
  }, []);
};

var _normalizeTreatment = function _normalizeTreatment() {
  var treatmentFromApi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Treatment is already normalized
  if (typeof treatmentFromApi.isMocked !== 'undefined') {
    return treatmentFromApi;
  }

  return (0, _utils.buildTreatment)(treatmentFromApi.key, treatmentFromApi.identifier, treatmentFromApi.parameters);
};

var _adaptTreatments = function _adaptTreatments() {
  var treatments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return treatments.map(_normalizeTreatment);
};

var _findTreatments = function _findTreatments() {
  var treatments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var predicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  return treatments.reduce(function (accumulator, treatment) {
    if (predicate(treatment)) {
      accumulator.push(treatment);
    }

    return accumulator;
  }, []);
};

var normalizeTreatment = _normalizeTreatment;
exports.normalizeTreatment = normalizeTreatment;

var createTreatmentRequest = function createTreatmentRequest() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var identifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (0, _utils.buildTreatmentRequest)(key, identifier);
};

exports.createTreatmentRequest = createTreatmentRequest;

var createBulkTreatmentRequest = function createBulkTreatmentRequest() {
  var requests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _utils.buildBulkTreatmentRequest)(requests);
};

exports.createBulkTreatmentRequest = createBulkTreatmentRequest;

var createExposureLogRequest = function createExposureLogRequest() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var identifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (0, _utils.buildExposureLogRequest)(key, identifier);
};

exports.createExposureLogRequest = createExposureLogRequest;

var createBulkExposureLogRequest = function createBulkExposureLogRequest() {
  var requests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _utils.buildBulkExposureLogRequest)(requests);
};

exports.createBulkExposureLogRequest = createBulkExposureLogRequest;

var getTreatment = function getTreatment() {
  var treatmentsFromApi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var identifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var adaptedTreatments = _adaptTreatments(treatmentsFromApi);

  var matchedTreatmentSet = _findTreatments(adaptedTreatments, function (treatment) {
    return treatment.key === key;
  });

  var matchedTreatment = (0, _utils.buildTreatment)(key, identifier, [], true);
  /*
  *  Only filter by identifier when necessary.
  */

  if (matchedTreatmentSet.length && identifier) {
    matchedTreatmentSet = _findTreatments(matchedTreatmentSet, function (treatment) {
      return treatment.identifier === identifier;
    });
  }

  if (matchedTreatmentSet.length) {
    matchedTreatment = matchedTreatmentSet[0];
  }

  return matchedTreatment;
};

exports.getTreatment = getTreatment;

var getParameter = function getParameter() {
  var parametersFromApi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var parameterKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var parameterOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  // Optionally handle treatment as 1st arg
  if (parametersFromApi && parametersFromApi.parameters && parametersFromApi.parameters.length !== undefined) {
    var treatment = normalizeTreatment(parametersFromApi);
    parametersFromApi = treatment.parameters;
  }

  var adaptedParameters = _adaptParameters(parametersFromApi);

  var matchedParameterSet = _findParameters(adaptedParameters, function (parameter) {
    return parameter.key === parameterKey;
  });

  var matchedParameter;
  var hasParameterOptions = parameterOptions && parameterOptions.length;
  var fallbackOption = hasParameterOptions ? parameterOptions[0] : '';
  var fallbackParameter = (0, _utils.buildParameter)(parameterKey, fallbackOption, false, true); // use first match

  if (matchedParameterSet.length) {
    matchedParameter = matchedParameterSet[0];
  } // dont allow unexpected values when options are passed


  if (hasParameterOptions && matchedParameter && parameterOptions.indexOf(matchedParameter.value) === -1) {
    matchedParameter = fallbackParameter;
  }

  return matchedParameter || fallbackParameter;
};

exports.getParameter = getParameter;

var getExposureLogRequest = function getExposureLogRequest() {
  var treatmentsFromApi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var treatments = []; // Conditionally accept single treatment

  if (typeof treatmentsFromApi.key === 'string' && typeof treatmentsFromApi.length === 'undefined') {
    treatments = _adaptTreatments([treatmentsFromApi]);
  } else {
    treatments = _adaptTreatments(treatmentsFromApi);
  }

  var requests = treatments.map(function (treatment) {
    return createExposureLogRequest(treatment.key, treatment.identifier);
  });
  return createBulkExposureLogRequest(requests);
};

exports.getExposureLogRequest = getExposureLogRequest;